import React from "react";
import styled, { css } from "styled-components";
import { Box } from "src/components/Box";
import { Card } from "src/components/Card";
import { IComboBoxOption, useComboBoxContext } from "./ComboBox.context";
import { ComboBoxOption } from "./ComboBox.option";
import { observer } from "mobx-react-lite";
import { useTranslation } from "src/hooks";

const WrapperEl = styled(Card)`
  left: 0;
  position: absolute;
  right: 0;
  top: 62px;

  ${(p) => css`
    background-color: ${p.theme.colors.background.white};
    border-radius: ${p.theme.dimension.borderRadius[0]}px;
    box-shadow: ${p.theme.colors.boxShadow.dropdown};
    padding: ${p.theme.dimension.spacing.l}px 0;
    z-index: ${p.theme.layout.zIndex.dropdown};
  `}
`;

const ContentWrapperEl = styled(Box)`
  // Shows 5 options maximum before scrolling
  max-height: calc(${(p) => p.theme.components.combobox.optionHeight}px * 5);
`;

const translation = {
  en: {
    empty_state: "No options match your selection...",
  },
  id: {
    empty_state: "Tidak ada pilihan yang cocok...",
  },
};

export const ComboBoxPanel = observer(() => {
  const translate = useTranslation(translation);
  const { panelState, filteredOptions } = useComboBoxContext();

  if (!panelState) {
    return null;
  }

  const PanelContent = React.memo((props: { options: IComboBoxOption[] }) => {
    if (!props.options.length) {
      return <ComboBoxOption readOnly label={translate("empty_state")} />;
    }
    return (
      <>
        {props.options.map((option, key) => (
          <ComboBoxOption key={key} label={option.label} value={option.value} />
        ))}
      </>
    );
  });

  return (
    <WrapperEl>
      <ContentWrapperEl overflowYScroll>
        <PanelContent options={filteredOptions} />
      </ContentWrapperEl>
    </WrapperEl>
  );
});
